export const diningOut = [
  {
    type: "restaurant",
    info: {
      resId: 19655522,
      name: "Ping's Café Orient",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/2/19655522/604d1f8a6730734636253c757a5c34b7_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/2/19655522/604d1f8a6730734636253c757a5c34b7_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/2/19655522/62a38b7ea78796acc483cd23963a37f7_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.4",
        rating_text: "4.4",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "1,137",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.4",
            reviewCount: "361",
            reviewTextSmall: "361 Reviews",
            subtext: "361 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.4",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.3",
            reviewCount: "776",
            reviewTextSmall: "776 Reviews",
            subtext: "776 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.3",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,000 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "DLF Avenue, Saket, New Delhi",
        address:
          "170A, Ground Floor, DLF Avenue, Saket District Centre, Saket, New Delhi",
        localityUrl: "ncr/restaurants/in/dlf-avenue-saket"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/thai/",
          name: "Thai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/sea-food/",
          name: "Seafood"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,000 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/pings-café-orient-1-saket-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.6 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19655522","element_type":"listing","rank":130}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/pings-café-orient?subzone=22&category=2"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20053994,
      name: "Big B's - Doners & More",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/4/20053994/818db42aca6788ba8fe7b554d352594b_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/4/20053994/818db42aca6788ba8fe7b554d352594b_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/4/20053994/cce02e42c85da078ae8bf50028e291f3_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.2",
        rating_text: "4.2",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "593",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.2",
            reviewCount: "48",
            reviewTextSmall: "48 Reviews",
            subtext: "48 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.2",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.2",
            reviewCount: "545",
            reviewTextSmall: "545 Reviews",
            subtext: "545 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.2",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "M Block Market, Greater Kailash 1 (GK1), New Delhi",
        address:
          "Shop 2, M-73, Ground Floor, M Block Market, Greater Kailash 1 (GK 1), New Delhi",
        localityUrl: "ncr/restaurants/in/m-block-market-greater-kailash-1-gk1"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTYxXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/shawarma/",
          name: "Shawarma"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/wraps/",
          name: "Wraps"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/coffee/",
          name: "Coffee"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NlwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/shake/",
          name: "Shake"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹400 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/big-bs-doners-more-greater-kailash-gk-1-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "1.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20053994","element_type":"listing","rank":131}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 4847,
      name: "Pizza Hut",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/246/4f548044a08b1794f6739b5053cd25f2_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/chains/6/246/4f548044a08b1794f6739b5053cd25f2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/246/5ca8db5083b0882ad64edd049395af7c_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.5",
        rating_text: "3.5",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "7,216",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.2",
            reviewCount: "293",
            reviewTextSmall: "293 Reviews",
            subtext: "293 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.2",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.8",
            reviewCount: "6,923",
            reviewTextSmall: "6,923 Reviews",
            subtext: "6,923 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.8",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,000 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Lajpat Nagar 2, New Delhi",
        address: "K-95, Lajpat Nagar 2, New Delhi",
        localityUrl: "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,000 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/pizza-hut-1-lajpat-nagar-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "1.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"4847","element_type":"listing","rank":132}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/pizza-hut?subzone=22&category=2"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20621381,
      name: "Wrap 'O' Burger",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/20621381/cbd7d3efaf21d7886f377f7e7b3a00c8_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/1/20621381/cbd7d3efaf21d7886f377f7e7b3a00c8_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/20621381/78ff9005d2c7cff7ad499f6c029b3ab8_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "NEW",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "22",
        subtext: "REVIEWS",
        is_new: true
      },
      ratingNew: {
        newlyOpenedObj: {
          text: "Newly Opened",
          color: "#FFFFFF",
          bgColor: "#F4A266",
          bgColorV2: {
            type: "green",
            tint: "100"
          },
          subtitle: "OUTLET",
          ratingV2: "New"
        },
        suspiciousReviewObj: null,
        ratings: []
      },
      cft: {
        text: "₹350 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Lajpat Nagar 2, New Delhi",
        address: "K-96-A, Ground Floor, Lajpat Nagar 2, New Delhi",
        localityUrl: "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/wraps/",
          name: "Wraps"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/burger/",
          name: "Burger"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹350 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/wrap-o-burger-lajpat-nagar-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "1.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20621381","element_type":"listing","rank":133}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/wrap-o-burger?subzone=22&category=2"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 19340773,
      name: "Storm Reloaded",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/3/19340773/de8086076c7c400981dea1b80c77b84f_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/3/19340773/de8086076c7c400981dea1b80c77b84f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/3/19340773/85becd01eae2da1698ba85e7116fe680_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.3",
        rating_text: "4.3",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "192",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.5",
            reviewCount: "175",
            reviewTextSmall: "175 Reviews",
            subtext: "175 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.5",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.0",
            reviewCount: "17",
            reviewTextSmall: "17 Reviews",
            subtext: "17 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.0",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,900 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "East of Kailash, New Delhi",
        address: "F-39, Block F, East of Kailash, New Delhi",
        localityUrl: "ncr/east-of-kailash-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxOFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/modern-indian/",
          name: "Modern Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,900 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/storm-reloaded-east-of-kailash-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "726 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19340773","element_type":"listing","rank":134}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/storm-reloaded-east-of-kailash-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures for a safe dining experience"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 18675921,
      name: "Welcome Chicken Corner",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/18675921/75a95b2454ff03794882c8fc1d71c510_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/1/18675921/75a95b2454ff03794882c8fc1d71c510_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/18675921/5855a8669aa3312f577b8b3aad4f9b57_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.1",
        rating_text: "4.1",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "11.2K",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.0",
            reviewCount: "141",
            reviewTextSmall: "141 Reviews",
            subtext: "141 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.0",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.1",
            reviewCount: "11K",
            reviewTextSmall: "11K Reviews",
            subtext: "11K Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.1",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹500 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "East of Kailash, New Delhi",
        address: "Shop 27, C Block Market, East of Kailash, New Delhi",
        localityUrl: "ncr/east-of-kailash-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mughlai/",
          name: "Mughlai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/momos/",
          name: "Momos"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/welcome-chicken-corner-east-of-kailash-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "687 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18675921","element_type":"listing","rank":135}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 7316,
      name: "Red Chilli",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/7316/5691e03ba759176f5e2fac0a9d1b6746_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/6/7316/5691e03ba759176f5e2fac0a9d1b6746_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/5918/d41a417338e24ce1639ce2889577f825_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.0",
        rating_text: "4.0",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "341",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.8",
            reviewCount: "172",
            reviewTextSmall: "172 Reviews",
            subtext: "172 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.8",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.1",
            reviewCount: "169",
            reviewTextSmall: "169 Reviews",
            subtext: "169 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.1",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,200 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Green Park, New Delhi",
        address:
          "S 15, Uphaar Cinema Complex, Opposite Metro Station, Green Park, New Delhi",
        localityUrl: "ncr/green-park-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mughlai/",
          name: "Mughlai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/sea-food/",
          name: "Seafood"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/biryani/",
          name: "Biryani"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,200 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/red-chilli-green-park-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.3 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"7316","element_type":"listing","rank":136}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/red-chilli-green-park-new-delhi/book"
      },
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/red-chilli?subzone=22&category=2"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 19817544,
      name: "Aquila",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/4/19817544/cc86a1f68d1c25ef560e1899de75cd44_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/4/19817544/cc86a1f68d1c25ef560e1899de75cd44_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/4/19817544/149d62c15f4b9266dbcef127ab066c9a_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "2.8",
        rating_text: "2.8",
        rating_subtitle: "Average",
        rating_color: "FFBA00",
        votes: "203",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "2.8",
            reviewCount: "201",
            reviewTextSmall: "201 Reviews",
            subtext: "201 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "2.8",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "yellow",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "2",
            reviewTextSmall: "2 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,800 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Ansal Plaza Mall, Khel Gaon Marg, New Delhi",
        address:
          "Ansal Plaza, C Block, Ground Floor, August Kranti Marg, Khel Gaon Marg, New Delhi",
        localityUrl: "ncr/restaurants/in/ansal-plaza-mall-khel-gaon-marg"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/pasta/",
          name: "Pasta"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,800 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/aquila-khel-gaon-marg-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "3.3 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19817544","element_type":"listing","rank":137}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/aquila-khel-gaon-marg-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 7886,
      name: "Naagar Foods",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/7886/e7de85e3ae2cd1e02209df4478f62eb9_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/6/7886/e7de85e3ae2cd1e02209df4478f62eb9_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/7886/75694f414fb1be4488e941845bba91f9_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.8",
        rating_text: "3.8",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "291",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.9",
            reviewCount: "59",
            reviewTextSmall: "59 Reviews",
            subtext: "59 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.9",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.6",
            reviewCount: "232",
            reviewTextSmall: "232 Reviews",
            subtext: "232 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.6",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "East of Kailash, New Delhi",
        address: "D 88, Amrit Puri B, East of Kailash, New Delhi",
        localityUrl: "ncr/east-of-kailash-delhi-restaurants"
      },
      timing: {
        text: "Closes in 23 minutes",
        color: "#ab000d"
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹400 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/naagar-foods-east-of-kailash-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "345 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"7886","element_type":"listing","rank":138}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 2583,
      name: "Cafe 27",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/3/2583/a4a9e765cb2eb7d64438a972f127762f_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/3/2583/a4a9e765cb2eb7d64438a972f127762f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/3/2583/5b3426df339ff43f8a2725078512c3f8_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.5",
        rating_text: "3.5",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "1,226",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.1",
            reviewCount: "1,204",
            reviewTextSmall: "1,204 Reviews",
            subtext: "1,204 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.1",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "2.8",
            reviewCount: "22",
            reviewTextSmall: "22 Reviews",
            subtext: "22 Delivery Reviews",
            color: "#E23744",
            ratingV2: "2.8",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "yellow",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,500 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Kailash Colony, New Delhi",
        address:
          "HS-26, 2nd Floor, Kailash Colony Market, Near Kailash Colony, New Delhi",
        localityUrl: "ncr/kailash-colony-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/sandwich/",
          name: "Sandwich"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/biryani/",
          name: "Biryani"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/momos/",
          name: "Momos"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NlwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/shake/",
          name: "Shake"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/cafe-27-kailash-colony-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "990 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"2583","element_type":"listing","rank":139}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/cafe-27-kailash-colony-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20614028,
      name: "Mr Boba Bubbles",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/20614028/c46f9f2bed29785ef11b13372e163c98_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/chains/8/20614028/c46f9f2bed29785ef11b13372e163c98_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/8/20614028/0f57e87f6ca504496a2d0aeba210b622_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.7",
        rating_text: "3.7",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "37",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.4",
            reviewCount: "10",
            reviewTextSmall: "10 Reviews",
            subtext: "10 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.4",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.0",
            reviewCount: "27",
            reviewTextSmall: "27 Reviews",
            subtext: "27 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.0",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹350 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Lajpat Nagar 2, New Delhi",
        address: "M 59, Shop 1, Lajpat Nagar 2, New Delhi",
        localityUrl: "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/coffee/",
          name: "Coffee"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjQ3XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/bubble-tea/",
          name: "Bubble Tea"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTYzXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/tea/",
          name: "Tea"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹350 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/mr-boba-bubbles-lajpat-nagar-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "1.2 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20614028","element_type":"listing","rank":140}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 19768232,
      name: "La Pino'z Pizza",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/7/18619067/e8dea05ca82398e2919ce9b4b6d1a2b6_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/chains/7/18619067/e8dea05ca82398e2919ce9b4b6d1a2b6_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/7/18619067/54b6de34323395a3b10897e48bd2a6e5_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.0",
        rating_text: "4.0",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "5,378",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.2",
            reviewCount: "442",
            reviewTextSmall: "442 Reviews",
            subtext: "442 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.2",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.8",
            reviewCount: "4,936",
            reviewTextSmall: "4,936 Reviews",
            subtext: "4,936 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.8",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹500 for two"
      },
      cfo: {
        text: "₹550 for one"
      },
      locality: {
        name: "Lajpat Nagar 2, New Delhi",
        address: "C-51, Central Market Road, Lajpat Nagar 2, New Delhi",
        localityUrl: "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/pasta/",
          name: "Pasta"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/la-pinoz-pizza-lajpat-nagar-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "1.9 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"07740338-6d8b-4efa-b49e-293fef5c1f73","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19768232","element_type":"listing","rank":141}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/la-pinoz-pizza-3?subzone=22&category=2"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures for a safe dining experience"
      }
    ]
  }
];
